import Layout from '@/layout';
var adminSettingRouter = {
  path: '/adminSetting',
  component: Layout,
  redirect: '/adminSetting/user',
  name: 'adminSetting',
  meta: {
    title: '管理员功能',
    icon: 'admin'
  },
  children: [{
    path: 'user',
    component: function component() {
      return import('@/views/admin/user');
    },
    name: 'AdminSettingUser',
    meta: {
      title: '管理员列表',
      icon: 'admin_user'
    }
  }]
};
export default adminSettingRouter;